{
	"userPresets": "User Presets",
	"presetNameWithNumber": "{{category}}-{{number}}",
	"categoryAiry": "Airy",
	"categoryBW": "BW",
	"categoryCream": "Cream",
	"categoryEarth": "Earth",
	"categoryMoody": "Moody",
	"categorySage": "Sage",
	"prefixAiry": "airy",
	"prefixBW": "bw",
	"prefixCream": "cream",
	"prefixEarth": "earth",
	"prefixMoody": "moody",
	"prefixSage": "sage"
}
